<template>
    <main id="liste" v-cloak>
        <HeaderTab :title="$t('invoice.control_properties')" :swiper_tabs="swiper_tabs" />

        <div id="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <router-view></router-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>


<script type="text/javascript">
    import Navigation from "@/mixins/Navigation.js";

	export default {
		name: "controlProperties",
		mixins: [Navigation],
		data () {
			return {
                param_tab: '',
                actual_tab: 'controlPropertiesActes'
			}
		},

		mounted() {
            this.param_tab = this.$route.params.actual_tab
		},

        computed: {
            swiper_tabs() {
                return [{
                        id: 'control_actes',
                        label: 'invoice.control_properties_actes',
                        active: false,
                        href : 'controlPropertiesActes'
                    }, {
                        id: 'control_porteuses',
                        label: 'invoice.control_properties_porteuses',
                        active: false,
                        href : 'controlPropertiesPorteuses',
                        hidden: !this.hasSaillieAccess
                    }
                ]
            },

            hasSaillieAccess() {
                return this.$store.state.userAccess.hasSaillieAccess
            }
        },
		components: {
            HeaderTab: () => import('@/components/HeaderTab'),
		}
	}
</script>
